<template>
    <section id="page9">
        <!-- <audio ref="closedoor" src="@/assets/sound/closedoor.mp3"></audio> -->
        <div class="background"></div>
        <div class="container">
            <div class="col-left">
                <lottie-player :src="`animas/0/page10.json`" v-if="persona==0" ref="lottiepage10" id="page10anima0"
                        loop="false"
                        transparent
                        style="width:80%">
                </lottie-player>
                <lottie-player :src="`animas/1/page10.json`" v-if="persona==1" ref="lottiepage10" id="page10anima1"
                        loop="false"
                        transparent
                        style="width:80%">
                </lottie-player>
                <!-- <img src="@/assets/img/jato.svg" alt="" class="jato"> -->
            </div>
            <div class="col-right">
                <div class="card" id="formcard">
                    <h2>Embarque com a gente nessa missão!</h2>
                    <p class="p1">Preencha seus dados no formulário abaixo e alguém da nossa tripulação entrará em contato com você.</p>
                    <p class="text-bold text-sm p1" v-if="sucesso && !falha">
                        Obrigado. Formulário enviado com sucesso!
                    </p>
                    <p
                        class="text-bold text-sm p1"
                        data-aos="fadeIn"
                        v-if="falha && !sucesso"
                    >
                        Ops! Ocorreu um erro ao enviar o seu formulário, tente
                        novamente.
                    </p>
                    <form
                        id="form"
                        @submit="submitForm($event)"
                        v-on:input="checkInput()"
                    >
                        <div class="subcontainer">
                            <div class="col-left">
                                <label for="nome">Nome</label>
                                <input
                                    size="2"
                                    class="campoForm"
                                    placeholder="Nome"
                                    v-model="form.nome"
                                    type="text"
                                    name="nome"
                                    min-length="8"
                                    required
                                    @keypress="preventNumber($event)"
                                />
                            </div>
                            <div class="col-right">
                                <label for="sobrenome">Sobrenome</label>
                                <input
                                    size="1"
                                    class="campoForm"
                                    placeholder="Sobrenome"
                                    v-model="form.sobrenome"
                                    type="text"
                                    name="sobrenome"
                                    required
                                    @keypress="preventNumber($event)"
                                />
                            </div>
                        </div>
                        <div class="subcontainer">
                            <div class="col-left">
                                <label for="email">E-Mail corporativo</label>
                                <input
                                    size="1"
                                    class="campoForm"
                                    placeholder="E-mail corporativo"
                                    v-model="form.email"
                                    type="email"
                                    name="email"
                                    v-on:blur="checkInput()"
                                    required
                                />
                            </div>
                            <div class="col-right">
                                <label for="telefone">Telefone</label>
                                <the-mask
                                    size="1"
                                    class="campoForm"
                                    placeholder="Telefone (00) 0000-0000"
                                    v-model="form.telefone"
                                    type="tel"
                                    name="telefone"
                                    @keypress="isNumber($event)"
                                    :mask="['(##) ####-####', '(##) #####-####']"
                                    required
                                />
                            </div>
                        </div>
                        <div class="subcontainer">
                            <div class="col-unique">
                                <label for="empresa">Empresa</label>
                                <input
                                    size="1"
                                    class="campoForm"
                                    placeholder="Empresa"
                                    v-model="form.empresa"
                                    type="text"
                                    name="empresa"
                                    required
                                />
                            </div>
                        </div>
                        <div class="subcontainer">
                            <div class="col-left">
                                <label for="nfunc">Número de colaboradores</label>
                                <select @click="checkInput()"
                                    size="1"
                                    class="campoForm select"
                                    placeholder="Número de colaboradores"
                                    :class="{ selectAlt: form.nfunc != null }"
                                    required="required"
                                    name="nfunc"
                                    v-model="form.nfunc"
                                >
                                    <option
                                        value="null"
                                        class="defaultSelect"
                                        disabled
                                        selected="selected"
                                        hidden
                                    >
                                        Escolha um...
                                    </option>
                                    <option value="Até 100">Até 100</option>
                                    <option value="101-200">101-200</option>
                                    <option value="201-500">201-500</option>
                                    <option value="501-1000">501-1000</option>
                                    <option value="1001-2500">1001-2500</option>
                                    <option value="2501-5000">2501-5000</option>
                                    <option value="5001-10000">5001-10000</option>
                                    <option value="Acima de 10000">Acima de 10000</option>
                                </select>

                            </div>
                            <div class="col-right">
                                <label for="cargo">Cargo</label>
                                <select  @click="checkInput()"
                                    class="campoForm select"
                                    :class="{ selectAlt: form.cargo != null }"
                                    required="required"
                                    name="cargo"
                                    v-model="form.cargo"
                                >
                                    <option
                                        value="null"
                                        selected="selected"
                                        disabled
                                        hidden
                                    >
                                        Escolha um...
                                    </option>
                                    <option value="Analista">Analista</option>
                                    <option value="Assistente">Assistente</option>
                                    <option value="Coordenador (a)">Coordenador (a)</option>
                                    <option value="Trainee/Estagiário (a)">Trainee/Estagiário (a)</option>
                                    <option value="Diretor (a)">Diretor (a)</option>
                                    <option value="Gerente">Gerente</option>
                                    <option value="Presidente">Presidente</option>
                                </select>
                            </div>
                        </div>
                        <div class="subcontainer">
                            <div class="col-left">
                                <label for="departamento">Departamento</label>
                                <select  @click="checkInput()"
                                    class="campoForm select"
                                    :class="{ selectAlt: form.departamento != null }"
                                    required="required"
                                    name="departamento"
                                    v-model="form.departamento"
                                >
                                    <option
                                        value="null"
                                        selected="selected"
                                        disabled
                                        hidden
                                    >
                                        Escolha um...
                                    </option>

                                    <option value="Administrativo">Administrativo</option>
                                    <option value="Comercial">Comercial</option>
                                    <option value="Compras">Compras</option>
                                    <option value="Contabilidade">Contabilidade</option>
                                    <option value="Pessoal">Pessoal</option>
                                    <option value="Recursos Humanos">Recursos Humanos</option>
                                    <option value="Presidência">Presidência</option>
                                    <option value="Tecnologia da Informação">Tecnologia da Informação</option>

                                </select>
                            </div>
                            <div class="col-right">
                                <label for="contato">Receber contato por</label>
                                <select  @click="checkInput()"
                                    class="campoForm select"
                                    :class="{ selectAlt: form.departamento != null }"
                                    required="required"
                                    name="contato"
                                    v-model="form.contato"
                                >
                                    <option
                                        value="null"
                                        selected="selected"
                                        disabled
                                        hidden
                                    >
                                        Escolha um...
                                    </option>
                                    <option value="E-Mail">E-Mail</option>
                                    <option value="Ligação">Ligação</option>
                                    <option value="Whatsapp">Whatsapp</option>
                                </select>
                               
                            </div>
                        </div>
                        <div v-if="aviso!=''">
                            <br>
                            <p v-html="aviso">

                            </p>
                        </div>
                        <div class="subcontainer">
                            <div class="col-checkbox">
                                
                                    <input @click="checkBox($event)" type="checkbox" name="opt-in" :value="checkBoxValue" class="checkbox">
                                <label for="opt-in" class="checkbox-label">
                                    Eu concordo que a LG lugar de gente me envie comunicações de marketing.
                                </label>
                            </div>
                        </div>
                        <div class="subcontainer">
                            <div class="col-unique">
                                <p>
                                    Você está fornecendo o seu consentimento para a LG lugar de gente para que possamos enviar comunicações de marketing. 
                                    Você pode revogar o seu consentimento a qualquer momento. Para mais informações, consulte nossa <a href="https://page.lg.com.br/lps/privacidade/" target="_blank">Política de Privacidade</a>.
                                </p>
                            </div>
                        </div>
                        <input type="hidden" name="formPard" value="https://pages.lg.com.br/l/688633/2023-02-23/253248i" />
                        <div class="subcontainer">
                            <div class="col-unique col-button">
                                <input
                                    class=" btnSubmit"
                                    :class="{ btnEnviarEnabled: submitActive == true, btnEnviarDisabled: submitActive == false}"
                                    :disabled="submitActive == false"
                                    type="submit"
                                    :value="submitLabel[submitStatus]"
                                />
                            </div>
                        </div>
                            
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { create } from '@lottiefiles/lottie-interactivity';
export default {
    props: ['persona', 'basicForm'],
    data() {
        return {
            soundPlayed: false,
            piAId: "689633",
            piCId: "1611",
            piHostname: "pi.pardot.com",
            form: {
                nome: null,
                sobrenome: null,
                email: null,
                empresa: null,
                nfunc: null,
                cargo: null,
                departamento: null,
                telefone: null,
                contato: null,
                "opt-in":"off",
                "formPard":"https://pages.lg.com.br/l/688633/2023-02-23/253248i"
            },
            submitActive: false,
            sucesso: false,
            falha: false,
            checkBoxValue:"off",
            submitStatus: 0,
            submitLabel: ["Enviar", "Carregando...", "Enviado com sucesso"],
            aviso:'',
            rejectList: [
                "gmail.com",
                "hotmail.com.br",
                "hotmail.com",
                "yahoo.com.br",
                "yahoo.com",
                "myyahoo.com",
                "uol.com.br",
                "bol.com.br",
                "icloud.com",
                "icloud.com.br"
            ]
        }
    },
    methods: {
        submitForm(evt) {
            evt.preventDefault();
            var form = document.querySelector('form');
            var formData = new FormData(form);
            
            console.log("Submit form");
            var myHeaders = new Headers();
            fetch('https://strapi.lg.com.br/integra-pardot', {
                method: 'POST',
                body: formData,
                headers:myHeaders,
            }).then(function(response){
                if (response.ok) {
                    location.assign('./sucesso.html');
                    conversaoGoogle();
                    conversaoFacebook();
                    return response;
                } else if (!response.ok){
                    this.falha = true;
                }
            })
            .then((data) => {
                
                this.resetForm();
            });

            this.$emit("visualizouPage3");
            setTimeout(function() {
                this.$scrollTo('.page4');
            }.bind(this), 400)

        },
        preventNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                return true;
            } else {
                evt.preventDefault();
            }
        },
        checkBox(evt){
            if(this.checkBoxValue == "off"){
                this.checkBoxValue = "on";
                this.form = Object.assign({}, this.form, {
                    "opt-in":"on"
                })
            } else{
                this.checkBoxValue = "off";
                this.form = Object.assign({}, this.form, {
                    "opt-in":"off"
                })
            }
            this.checkInput();


        },
        checkInput() {
            console.log("CHECKINPUT, ", this.form);
            if (
                !this.form.nome ||
                !this.form.sobrenome ||
                !this.form.email ||
                !this.form.telefone ||
                !this.form.empresa ||
                !this.form.nfunc ||
                !this.form.cargo ||
                !this.form.departamento ||
                !this.form.contato

            ) {
                this.submitActive = false;
            } else {
                if(this.checkemail()){
                    this.submitActive = true;
                }else{
                    this.submitActive = false;
                }
            }
        },
        checkemail(){

            if(!this.form.email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
                //se não for um email válido
                this.aviso = "Preencha por favor com um <b>email válido</b>.";
                return false;
            }else{
                //se for email valido, verifica se é corporativo
                var emailValue = this.form.email ;
                var splitArray = emailValue.split('@');
                if(this.rejectList.indexOf(splitArray[1]) >= 0){
                    // existe na lista
                    this.aviso = "Preencha por favor com um <b>email corporativo</b>.";
                    return false;
                }else{
                    this.aviso = "";
                    console.log("deu certo")
                    return true;
                }
            }
        },
        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        resetForm() {
            this.form.nome = 
            this.form.sobrenome = 
            this.form.email = 
            this.form.empresa = 
            this.form.cargo = 
            this.form.departamento = 
            this.form.telefone = "";
            this.form.contato = 
            
            this.form.nfunc = null;
            this.form.estado = null;
            this.sucesso = true;
        },
    },
    created: function () {
        this.piAId = "689633";
        this.piCId = "1611";
        this.piHostname = "pi.pardot.com";

        (function () {
            function async_load() {
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src =
                    ("https:" == document.location.protocol
                        ? "https://pi"
                        : "http://cdn") + ".pardot.com/pd.js";
                var c = document.getElementsByTagName("script")[0];
                c.parentNode.insertBefore(s, c);
            }
            if (window.attachEvent) {
                window.attachEvent("onload", async_load);
            } else {
                window.addEventListener("load", async_load, false);
            }
        })();
    },
    mounted() {
        if(this.basicForm.nome && this.basicForm.email) {
            this.form.nome = this.basicForm.nome;
            this.form.email = this.basicForm.email;
        }
         if(this.persona == 0) {
            this.$refs.lottiepage10.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page10anima0',
                        actions: [
                            {
                                visibility:[0, 0.2],
                                type: "stop",
                                frames: [0]
                            },
                            {
                                visibility: [0.2, 0.45],
                                type: "seek",
                                frames: [1, 65]
                            },
                        ],
                });
            })
            // let animation = document.getElementById("page10anima0");
            // animation.addEventListener("frame", () => {
            //     console.log("FRAME ")
            //     if(this.soundPlayed == false) {
            //         this.soundPlayed = true;
            //         this.$refs.closedoor.play();
            //     }
            // });
        } else {
            this.$refs.lottiepage10.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page10anima1',
                        actions: [
                            // {
                            //     visibility: [0, .2],
                            //     type: "play"
                            // }
                             {
                                visibility:[0, 0.2],
                                type: "stop",
                                frames: [0]
                            },
                            {
                                 visibility: [0.2, 0.45],
                                type: "seek",
                                frames: [1, 65]
                            },
                        ],
                });
            })
        }

        
    }
}
</script>
<style lang="scss" scoped>
section {
    background: rgb(117,142,255);
    background: linear-gradient(0deg, rgba(117,142,255,1) 0%, rgba(221,255,255,1) 100%);
    position: relative;
    
    p {
        font-size: 0.875rem;
    }
    .background {
        position: absolute;
        // top: 403px;
        left: 0;
        height: 100%;
        width: 100%;
        background-image: url("~@/assets/img/page9-bg.svg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center bottom;
        z-index: 101;
    }
    .container {
        position: relative;
        z-index: 102;
        // padding-top: 181px;
        align-items: stretch;
        & > .col-left {
            flex: 1;
            position: relative;
            // height: 230%;
            flex-basis: 50%;
            // max-height: 100%;
            #page10anima0, #page10anima1 {
                position: relative;
                z-index: 51;
                margin: 0 auto;
                max-width: 420px;
            }
            background-image: url("~@/assets/img/jato.svg");
            background-size: auto;
            background-repeat: no-repeat;
            background-position: center bottom;
            .jato {
                position: absolute;
                z-index: 50;
                bottom: -435px;
                left: 50%;
                // height: 150px;
                transform: translateX(-50%);
                overflow: hidden;
            }
        }
        & > .col-right {
            flex-basis: 50%;
            // justify-self: center;
            align-self: center;
        }
        .col-unique {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
                max-width: 100%;
            }
        }
        .col-right {
            a {
                color: rgb(255, 174, 3);
            }
            .card {
                display: flex;
                flex-direction: column;
                text-align: left;
                margin-top: 200px;
                margin-bottom: 151px;
                background-color: white;
                box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
                border-radius: 28px;
                color: $color-text-dark;
                padding: 34px 41px;
                max-width: 607px;
                // max-width: 50%;
                // min-height: 500px;
                h2 {
                    padding-bottom: 30px;
                }
                .p1 {
                    padding-bottom: 30px;
                }
                .subcontainer {
                    display: flex;
                    padding-top: 10px;
                    .col-unique {
                        align-items: flex-start;
                        flex-basis: 100%;
                        text-align: left;
                        margin-left: 0;
                        margin-right: 0;
                        width: 100%;
                        input {
                            // width: 100%;
                        }
                    }
                    .col-button {
                        align-items: center;
                    }
                    .col-left {
                        margin-left: 0;
                        flex-basis: 49%;
                    }
                    .col-right {
                        margin-right: 0;
                        flex-basis: 49%;
                    }
                }
                .btnSubmit {
                    box-shadow: 0px 3px 16px 0px rgba(34,0,80,0.6);
                    margin-top: 20px;
                    border: 1px solid #FFC346;
                    background-color: #FFAE03;
                    color: white;
                    max-width: 200px;
                    height: 40px;
                    border-radius: 28px;
                    cursor: pointer;
                    user-select: none;
                    // padding: 20px 0;
                    // display: flex;
                    // justify-content: center;
                    // align-items: center;
                    &:disabled {
                        cursor: default;
                        opacity: .5;
                    }
                }
                .col-checkbox {
                    padding-top: 20px;
                    color: $color-primary;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    input {
                        flex-shrink: 0;
                    }
                    
                }
            }
        }
    }
    @media only screen and (max-width: 992px) {
        .container {
            flex-direction: column;
            & > .col-left {
                padding-top: 60px;
            }
            & > .col-right {
                .card {
                    margin-top: 0;
                }
            }
        }
    }
    @media only screen and (max-width: 600px) {
        .container {
            .col-right {
                .card {
                    
                    padding: 20px $column-lateral-margin-mobile;
                    .subcontainer {
                        align-items: flex-end;
                        // .col-left, .col-right, .col-center, .col-unique {
                        //     margin-left: $column-lateral-margin-mobile;
                        //     margin-right: $column-lateral-margin-mobile;
                        // }
                    }
                }
            }
        }
    }
}
</style>